import { render, staticRenderFns } from "./VAutocompleteBigData.vue?vue&type=template&id=3e6783bb&scoped=true"
import script from "./VAutocompleteBigData.vue?vue&type=script&lang=js"
export * from "./VAutocompleteBigData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6783bb",
  null
  
)

export default component.exports